<script>
</script>

<button class="UISubcategoryButton" on:click >
	<span><slot /></span>
</button>

<style global>
	.UISubcategoryButton {
		width: 100%;
		padding: 1em 0.25em;
		text-align: left;
	}
	@media screen and (min-width: 480px) {
		.UISubcategoryButton {
			width: 50%;
			padding: 0.5em 0.25em;
		}
	}
	@media screen and (min-width: 960px) {
		.UISubcategoryButton {
			width: 33.3%;
			padding: 1em;
		}
	}
	.UISubcategoryButton {
		border: 1px solid #bb5858;
		box-shadow: 0 2px 0 rgba(187, 88, 88, 0.1);
		appearance: none;
		background: #fff;
		color: #bb5858;
		padding: 0.5em 1.5em;
		border-radius: 10em;
		text-align: center;
		max-width: 90%;
		width:100%;
		cursor: pointer;
		transition: background 100ms linear;
		position: relative;
		font-size: 0.9em;
	}
	:global(.pc) .UISubcategoryButton {
		min-width: 350px;
		max-width: 400px;
		font-size: 1em;
	}
	:global(.pc) .UISubcategoryButton:hover {
		background: #bb5858;
		color: #fff;
	}
	.UISubcategoryButton:focus-visible {
		border: 1px dashed #d77;
	}
	.UISubcategoryButton > span {
		display: inline-block;
		font-size: 1.1em;
	}
	.UISubcategoryButton :global(small) {
		font-size: 0.75em;
	}
</style>
